import React from 'react'
import PropTypes from 'prop-types'

import { Form, Select } from 'antd'
import { UserOutlined } from '@ant-design/icons'

const TargetStep = ({
  countries,
  getPotentialUsers,
  isLoading,
  onCountryChange,
  potentialUsers,
  targetItemList,
}) => (
  <>
    <Form.Item label="Country" name="country_id" rules={[{ message: 'Please select a country!', required: true }]}>
      <Select
        loading={isLoading.countryList}
        onChange={onCountryChange}
        options={countries.map((country) => ({ label: country.name, value: country.id }))}
      />
    </Form.Item>

    <Form.Item label="Target user if..." name="target_skus">
      <Select
        loading={isLoading.targetItemList}
        mode="multiple"
        onChange={getPotentialUsers}
        options={targetItemList.map(({ name, sku }) => ({ label: `${name} (${sku})`, value: sku }))}
        placeholder="select products"
        style={{ width: '100%' }}
      />
    </Form.Item>

    <Form.Item label="User ZIP code start with..." name="zip_codes">
      <Select
        mode="tags"
        onChange={getPotentialUsers}
        placeholder="type ZIP code(s)"
        style={{ width: '100%' }}
      />
    </Form.Item>

    <Form.Item label="User type" name="user_type">
      <Select onChange={getPotentialUsers}
        options={[
          { label: 'Regular and corporate', value: 'regular_and_corporate' },
          { label: 'Regular', value: 'regular' },
          { label: 'Corporate', value: 'corporate' },
        ]}
      />
    </Form.Item>

    <p style={{ opacity: isLoading.potentialUsers ? 0.1 : 1 }}>
      {potentialUsers?.percentage_in_selected_country}% of potential users are eligible for this campaign: <b>{potentialUsers?.count_of_notified_users}<UserOutlined /></b>
    </p>
  </>
)

TargetStep.propTypes = {
  countries: PropTypes.array,
  getPotentialUsers: PropTypes.func,
  isLoading: PropTypes.object,
  onCountryChange: PropTypes.func,
  potentialUsers: PropTypes.object,
  targetItemList: PropTypes.array,
}

export default TargetStep
